import React, { useEffect, useRef, useState } from 'react'
import consumer from '../../../src/cable'
import { formatTenantTime } from '../../utils/formatTenantDateTime'
import { LocalizationContextType } from './contexts'

interface BusinessAlert {
  id: number
  message: string
  level: string
  sent_at: string
}

// Cap the visible stack; older alerts roll off (full history is on the admin alerts page).
const MAX_VISIBLE = 10

const levelToBootstrapType = (level: string): string => {
  switch (level) {
    case 'error':
    case 'fatal':
      return 'danger'
    case 'warning':
      return 'warning'
    default:
      return 'info'
  }
}

const BusinessAlertToaster = (
  { location_id, localization_context }: { location_id: number, localization_context?: LocalizationContextType }
) => {
  const [alerts, setAlerts] = useState<BusinessAlert[]>([])
  const channel = useRef<any>(null)

  const dismiss = (id: number) => {
    setAlerts(current => current.filter(alert => alert.id !== id))
  }

  const addAlert = (alert: BusinessAlert) => {
    setAlerts(current => {
      if (current.some(a => a.id === alert.id || a.message === alert.message)) return current
      return [...current, alert].slice(-MAX_VISIBLE)
    })
  }

  useEffect(() => {
    if (!location_id) return

    channel.current = consumer.subscriptions.create(
      { channel: 'BusinessAlertChannel', location_id },
      { received: (data: BusinessAlert) => addAlert(data) }
    )

    return () => {
      channel.current?.unsubscribe()
    }
  }, [location_id])

  if (alerts.length === 0) return null

  return (
    <div
      className="position-fixed d-flex flex-column gap-2"
      style={{ bottom: '20px', right: '20px', zIndex: 9999, maxWidth: '360px' }}
    >
      {alerts.map(alert => (
        <div key={alert.id} className={`alert alert-${levelToBootstrapType(alert.level)} mb-0 shadow`}>
          <div className="d-flex justify-content-between align-items-center">
            <strong className="me-2">{alert.message}</strong>
            <i className="bi bi-x-circle-fill pointer" onClick={() => dismiss(alert.id)} />
          </div>
          <div className="small">{formatTenantTime(alert.sent_at, localization_context)}</div>
        </div>
      ))}
    </div>
  )
}

export default BusinessAlertToaster
